import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: false,
});

let _token = null;

export function setAuthToken(token) {
    _token = token;
    if (token) {
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        try { localStorage.setItem("co_token", token); } catch (e) { /* ignore quota */ }
    } else {
        delete api.defaults.headers.common.Authorization;
        try { localStorage.removeItem("co_token"); } catch (e) { /* ignore */ }
    }
}

export function loadAuthTokenFromStorage() {
    try {
        const t = localStorage.getItem("co_token");
        if (t) setAuthToken(t);
        return t;
    } catch (e) {
        return null;
    }
}

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    }
    // Structured object detail (e.g. { error, message, ...extras })
    if (detail && typeof detail === "object") {
        if (typeof detail.message === "string") return detail.message;
        if (typeof detail.msg === "string") return detail.msg;
        if (typeof detail.error === "string") return detail.error;
    }
    return String(detail);
}
